<template>
  <div>
    <div class="map" id="map"></div>
    <div class="copy" @click="copy">点击复制</div>
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';

function copyText(text) {
  if (window.navigator && window.navigator.clipboard && window.navigator.clipboard.writeText) {
    window.navigator.clipboard.writeText(text);
    return;
  }
  const textareaC = document.getElementById('copy');
  textareaC.select();
  document.execCommand('copy');
}

function saveLoc(name, data) {
  const { localStorage } = window;
  localStorage.setItem(name, JSON.stringify(data));
}

function getLoc(name) {
  const { localStorage } = window;
  const data = localStorage.getItem(name);
  if (!data) {
    return null;
  }
  return JSON.parse(data);
}

const WX_LOC = 'loc_test_wx';
const H5_LOC = 'loc_test_h5';

export default {
  data() {
    return {
      query: '',
      pos: '',
    };
  },
  computed: {
    result() {
      const { query, pos } = this;
      return `小程序定位信息：${query}\nh5定位信息：${pos || '正在定位...'}`;
    },
  },
  mounted() {
    const { query } = this.$route;
    console.log(query);
    this.query = JSON.stringify(query || {});
    this.startLoc();
  },
  methods: {
    copy() {
      const { result } = this;
      copyText(result);
    },
    async startLoc() {
      const that = this;
      const { query } = this.$route;
      const mks = [];
      try {
        const AMap = await AMapLoader.load({
          key: 'e38fd0e1b995ca6aefc8e4f683a0eaa8',
          version: '2.0',
          plugins: ['AMap.Geolocation'],
        });
        const oldWX = getLoc(WX_LOC);
        const oldH5 = getLoc(H5_LOC);
        if (oldWX && oldWX.longitude) {
          mks.push(new AMap.Marker({
            position: new AMap.LngLat(oldWX.longitude - 0, oldWX.latitude - 0),
            label: {
              content: 'wx_old',
              direction: 'top',
            },
          }));
        }
        if (oldH5 && oldH5.longitude) {
          mks.push(new AMap.Marker({
            position: new AMap.LngLat(oldH5.longitude - 0, oldH5.latitude - 0),
            icon: '//vdata.amap.com/icons/b18/1/2.png',
            label: {
              content: 'h5_old',
              direction: 'top',
            },
          }));
        }
        mks.push(new AMap.Marker({
          position: new AMap.LngLat(query.longitude - 0, query.latitude - 0),
          label: {
            content: 'wx_new',
            direction: 'top',
          },
        }));
        const map = new AMap.Map('map', {
          animateEnable: false,
        });
        map.add(mks);
        map.setFitView(mks);
        saveLoc(WX_LOC, query);
        const geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认:true
          timeout: 1000 * 10, // 超过10秒后停止定位，默认：5s
        });
        geolocation.getCurrentPosition((status, result) => {
          if (status === 'complete') {
            const { position } = result;
            mks.push(new AMap.Marker({
              position,
              icon: '//vdata.amap.com/icons/b18/1/2.png',
              label: {
                content: 'h5_new',
                direction: 'top',
              },
            }));
            map.add(mks);
            map.setFitView(mks);
            saveLoc(H5_LOC, {
              longitude: position.lng,
              latitude: position.lat,
            });
            console.log(position);
            that.pos = position.toString();
          } else {
            that.onErr(result);
          }
        });
      } catch (err) {
        this.onErr(err);
      }
    },
    onErr(err) {
      console.log('onErr:', err);
      const str = JSON.stringify(err);
      setTimeout(() => {
        window.alert(str);
      }, 1000 * 3);
    },
  },
};
</script>

<style lang="scss" scoped>
.map {
  display: block;
  width: 100vw;
  height: 100vh;
}

.copy {
  position: fixed;
  left: 1rem;
  bottom: 1rem;
  font-size: 0.7rem;
}
</style>
